import JsEvent from '@rotomeca/event';
import BnumElement from 'components/bnum-element';
import ElementChangedEvent from 'core/utils/events/ElementChangedEvent';
import { EVENT_ICON_CHANGED } from './constants';

export function OnIconChangeInitializer(
  event: JsEvent<(newIcon: string, oldIcon: string) => void>,
  self: BnumElement,
) {
  event.add('default', (newIcon: string, oldIcon: string) => {
    self.dispatchEvent(
      new ElementChangedEvent(EVENT_ICON_CHANGED, newIcon, oldIcon, self),
    );
  });
}
